import { render, staticRenderFns } from "./VersionsDialog.vue?vue&type=template&id=1aeec698&scoped=true&"
import script from "./VersionsDialog.vue?vue&type=script&lang=js&"
export * from "./VersionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./VersionsDialog.vue?vue&type=style&index=0&id=1aeec698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeec698",
  null
  
)

export default component.exports